import React, {useEffect} from 'react'
import { Route } from 'react-router-dom'
import {MemoryRouter, useHistory, useLocation} from 'react-router'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import * as ls from 'utils/localStorage'
import ClearIcon from '@material-ui/icons/Clear'

import { checkVersionAndRefresh } from 'utils/versionCheck'
import { config } from 'api'

import { JobBoardPage } from 'pages/dentist/JobBoardPage'
import { JobBoardDetailsPage } from 'pages/dentist/JobBoardDetailsPage'
import CandidatePage from 'pages/dentist/CandidatePage'
import JobPostFeedbackPage from 'pages/dentist/JobPostFeedbackPage'
import CandidateResumePage from 'pages/dentist/CandidateResumePage'
import JobDeleteSuccessPage from 'pages/dentist/JobDeleteSuccessPage'
import DentistHomePage from 'pages/dentist/DentistHomePage'
import InvoicesPage from 'pages/dentist/InvoicesPage'
import LocationsListPage from 'pages/dentist/LocationsListPage'
import LocationAddPage from 'pages/dentist/LocationsPage/LocationAddPage'
import LocationDetailsPage from 'pages/dentist/LocationsPage/LocationDetailsPage'
import PaymentInfoPage from 'pages/dentist/PaymentInfoPage'
import DentistJobsForDatePage from 'pages/dentist/DentistJobsForDatePage'
import OfficeCeCoursesPage from 'pages/dentist/OfficeCeCoursesPage'

import EditJobPostFirstStep from 'pages/dentist/EditJobPostFirstStep'
import EditJobPostSecondStep from 'pages/dentist/EditJobPostSecondStep'
import EditJobPostOverviewStep from 'pages/dentist/EditJobPostOverviewStep'

import EditJobPostPositionPage from 'pages/dentist/EditJobPostPositionPage'
import EditJobPostOfficeLocationPage from 'pages/dentist/EditJobPostOfficeLocationPage'
import EditJobPostAvailabilityPage from 'pages/dentist/EditJobPostAvailabilityPage'
import EditJobPostDatesPage from 'pages/dentist/EditJobPostDatesPage'
import EditJobPostCandidateRequirementsPage from 'pages/dentist/EditJobPostCandidateRequirementsPage'
import EditJobPostTitleDescriptionPage from 'pages/dentist/EditJobPostTitleDescriptionPage'
import EditJobPostConfirmationPage from 'pages/dentist/EditJobPostConfirmationPage'
import EditJobPostSuccessPage from 'pages/dentist/EditJobPostSuccessPage'
import CustomOfferDetailsPage from 'pages/dentist/CustomOfferDetailsPage'
import JobBoardCandidateTemplatePage from 'pages/dentist/JobBoardCandidateTemplatePage/JobBoardCandidateTemplatePage'

import PostJob from "./pages/dentist/FindATempPageV2";

import AvailableJobsPage from 'pages/hygienist/AvailableJobsPage'
import JobPostsListPage from 'pages/hygienist/JobPostsListPage'
import JobAlertsPage from 'pages/hygienist/JobAlertsPage/JobAlertsPage'
import JobPostDetailsPage from 'pages/hygienist/JobPostDetailsPage'
import PartialOfferPage from "./pages/hygienist/PartialOfferPage";
import AvailableJobPage from "./pages/hygienist/AvailableJobPage";
import ConfirmedOfferPage from "./pages/hygienist/ConfirmedOfferPage";
import InstaBookConfirmationPage from "./pages/hygienist/InstaBookConfirmationPage";
import HygienistMessengerPage from './pages/hygienist/MessengerPage';
import CompleteJobPage from "./pages/hygienist/CompleteJobPage";
import HygienistInvoicePage from "./pages/hygienist/InvoicePage/Invoice";
import PaymentInformationPage from "./pages/hygienist/PaymentInformationPage";
import InvoiceDisputePage from "./pages/hygienist/InvoiceDisputePage";
import HygienistInvoicesList from "./pages/hygienist/InvoicesListPage";
import ContactSupport from "./pages/hygienist/ContactSupport";
import DOContactSupport from 'pages/dentist/ContactSupport'
import HygienistHomePage from 'pages/hygienist/HygienistHomePage'
import HygienistJobHistoryPage from 'pages/hygienist/JobHistoryPage'
import JobCompletedPage from 'pages/dentist/JobCompletedPage'
import ManualBookShiftPage from 'pages/hygienist/ManualBookShiftPage'

import HygienistDeleteAccount from 'pages/hygienist/DeleteAccount'
import DentistDeleteAccount from 'pages/dentist/DeleteAccount'

import MarketingMessaging from "./pages/landing/MarketingMessaging";
import ForgotPassword from "./pages/landing/ForgotPassword"
import ResetPassword from "./pages/landing/ResetPassword"
import Login from "./pages/landing/Login";
import RoleSelect from "./pages/landing/RoleSelect";
import SignUp0 from './pages/landing/SignUp0'
import SignUp1_DO from './pages/landing/SignUp1_DO'
import SignUp2_DO from "./pages/landing/SignUp2_DO";
import SignUp1_Talent from './pages/landing/SignUp1_Talent'
import SignUp2_Talent from './pages/landing/SignUp2_Talent'
import Onboarding_DO from './pages/landing/Onboarding_DO'
import Onboarding_Talent from './pages/landing/Onboarding_Talent'
import SignUp_PaymentInfo from './pages/landing/SignUp_PaymentInfo'

import createStore, { entities } from 'reduxStore'
import {usePersistedState} from 'hooks'
import Api from "./api";
import {roles} from "utils/constants";
import Landing from "./pages/landing/Landing";
import _ from "lodash";
import {HygienistProps, UserAccountProps} from "./utils/types";
import {
	PUBLIC_PAGE_ROUTES,
	getCompletedProfileDefaultRoute,
	getFeedbackNavigationGuard,
} from './App.navigation';
import InvoicePage from "./pages/dentist/InvoicePage";
import CustomOfferPage from "./pages/dentist/CustomOfferPage";
import CustomOffersPage from "./pages/dentist/CustomOffersPage";

import DentistConfirmedOfferPage from "./pages/dentist/ConfirmedOfferPage";
import DentistMessengerPage from 'pages/dentist/MessengerPage';
import ModifyJobPage from "./pages/dentist/ModifyJobPage";
import ProfilePage from "./pages/hygienist/ProfilePage";
import ForcedQualificationPage from "./pages/hygienist/ForcedQualificationPage/ForcedQualificationPage";
import Download from "./pages/landing/Download";
import JobInfoPage from 'components/JobBoardDetails/JobInfo/JobInfo'
import HygienistDeleteAccountSecondStep from 'pages/hygienist/DeleteAccountSecondStep'
import CancelJobPage from "./pages/hygienist/CancelJobPage";
import JobPostedPage from "./pages/dentist/JobPostedPage/JobPostedPage";
import LocationPage from 'pages/dentist/LocationPage/LocationPage'
import { MyStats } from "./pages/hygienist/MyStatsPage";
import FeedbackPage from "./pages/dentist/FeedbackPage/FeedbackPage";
import HygienistFeedbackPage from "./pages/hygienist/FeedbackPage";
import { createTheme, ThemeProvider } from '@mui/material'
import AutoBookPage from 'pages/hygienist/AutoBookPage'
import MixpanelLogs from 'pages/tools/MixpanelLogs'
import CoursesHomePage from 'pages/hygienist/CoursesHomePage'
import CourseDetailsPage from 'pages/hygienist/CourseDetailsPage'
import CoursePlayerPage from 'pages/hygienist/CoursePlayerPage'
import CourseReturnPage from 'pages/hygienist/CourseReturnPage'
import {
	initNativeAppShell,
	getAndroidBackAction,
	registerAndroidBackHandler,
	exitNativeAppFromAndroidBack,
	isAndroidLoadingRoute,
} from './utils/nativeApp'
import { installAvailableJobsBrowserHistory } from './utils/availableJobsBrowserHistory'

const { store, persistor } = createStore()

// @ts-ignore
const app = window?.app;

export interface PageDataProps {
	page: string,
	date?: string,
}

const DefaultRoute = () => {
	const history = useHistory();
	const [loading, setLoading] = React.useState<boolean>(false)
	const setUser = usePersistedState({
		entityName: entities.user,
	})[1];

	const setDentistUser = usePersistedState({
		entityName: entities.dentistUser,
	})[1];

	const setHygienist = usePersistedState({
		entityName: entities.hygienist,
	})[1]

	let user = usePersistedState<UserAccountProps>({
		entityName: entities.user
	})[0];

	let hygienist = usePersistedState<HygienistProps>({
		entityName: entities.hygienist
	})[0];

	const getRoute = async (userAccount?: UserAccountProps, pageData?: PageDataProps) => {
		if (pageData && PUBLIC_PAGE_ROUTES.includes(pageData.page)) {
			if (pageData.page === 'SignUp1_DO') {
				await Api.updateToken();
			}
			return pageData.page;
		}
		try {
			// Redirect users with complete profiles to their dashboards
			const completedRoute = getCompletedProfileDefaultRoute(userAccount, pageData);
			if (completedRoute) {
				return completedRoute;
			}

			// Handle users with incomplete profiles
			if (userAccount?.email?.length) {
				if (!!userAccount?.hygienistId && !!userAccount?.hygienist?.firstName) {
					return 'SignUp2_Talent';
				} else {
					const { roleId } = await Api.getRole()
					return roleId === roles.DENTIST ? 'SignUp1_DO' : 'SignUp1_Talent';
				}
			}
		} catch (e) {
			console.log('Error getting role and user', e);
			return 'landing';
		}
		return 'landing';
	};

	const handleStorageChange = async () => {
		setLoading(true)
		const data = ls.get<PageDataProps>('pageData');
		const jwt = ls.get('userAuth');

		if (data) {
			// Guard: prevent stray auto-redirects to hygienistFeedback unless explicitly allowed
			try {
				const allowFeedback = ls.get('feedbackNav');
				const feedbackGuard = getFeedbackNavigationGuard(data, allowFeedback);
				if (feedbackGuard.blocked) {
					ls.remove('pageData');
					setLoading(false)
					return;
				}
				if (feedbackGuard.removeFeedbackNav) {
					ls.remove('feedbackNav');
				}
			} catch {}
			ls.remove('pageData');

			if (jwt) {
				if(!user || !hygienist) {
					user = ls.get<UserAccountProps>('userAccount')
					if (_.isEmpty(user)) {
						user = await Api.getUser()
					}
					ls.set<UserAccountProps>('userAccount', user as UserAccountProps)
					setUser(user);
					if (user?.hygienist) {
						setHygienist(user?.hygienist);
					}
					if (user?.dentist) {
						setDentistUser(user)
					}
				} else {
					user = ls.get<UserAccountProps>('userAccount')
					if(!_.isEmpty(user)){
						setUser(user);
						if (user?.hygienist) {
							setHygienist(user?.hygienist);
						}
						if (user?.dentist) {
							setDentistUser(user)
						}
					}
				}

				getRoute(user, data).then((page) => {
					setLoading(false)
					const navigation = {
						pathname: page,
						state: { ...data },
					};
					if (isAndroidLoadingRoute(history.location.pathname)) {
						history.replace(navigation);
					} else {
						history.push(navigation);
					}
				});
			} else {
				getRoute(undefined, data).then((page) => {
					setLoading(false)
					const navigation = {
						pathname: page,
						state: { ...data },
					};
					if (isAndroidLoadingRoute(history.location.pathname)) {
						history.replace(navigation);
					} else {
						history.push(navigation);
					}
				});
			}
		}
		setLoading(false)
	};

	useEffect(() => {
		const initializeApp = async () => {
			try {
				const versionOk = await checkVersionAndRefresh(config.server.baseUrl);
				if (!versionOk) {
					return;
				}
			} catch (error) {
				console.error('Version check failed:', error);
			}

			window.addEventListener('storage', handleStorageChange, false);
			handleStorageChange();
		};

		initializeApp();

		return () => {
			window.removeEventListener('storage', handleStorageChange, false);
		};
	}, []);

	return loading ? <div className="background">
		Redirecting...
	</div> : null;
};

const AndroidBackButtonHandler = () => {
	const history = useHistory();
	const location = useLocation();
	const messengerReturnState = location.state as {
		returnTo?: { pathname?: string };
		preferReturnToOnBack?: boolean;
	} | undefined;
	const returnToPathname = messengerReturnState?.returnTo?.pathname;
	const preferReturnToOnBack = messengerReturnState?.preferReturnToOnBack === true;

	useEffect(() => (
		registerAndroidBackHandler({
			getAction: () => {
				const memoryHistory = history as unknown as {
					entries?: Array<{ pathname: string }>;
					index?: number;
				};
				return getAndroidBackAction({
					pathname: location.pathname,
					historyLength: history.length,
					entries: memoryHistory.entries,
					index: memoryHistory.index,
					returnToPathname,
					preferReturnToOnBack,
				});
			},
			onBack: (steps) => {
				if (steps <= 0) {
					exitNativeAppFromAndroidBack();
					return;
				}
				history.go(-steps);
			},
			onReplace: (pathname: string) => history.replace({ pathname }),
			onExit: exitNativeAppFromAndroidBack,
		})
	), [history, location.pathname, preferReturnToOnBack, returnToPathname]);

	return null;
};

const AvailableJobsBrowserBackHandler = () => {
	const history = useHistory();

	useEffect(() => installAvailableJobsBrowserHistory({
		memoryHistory: history,
		browserHistory: window.history,
		browserEvents: window,
		currentUrl: () => window.location.href,
	}), [history]);

	return null;
};

function App() {
	// Legacy startup can queue a route before React mounts. DefaultRoute must
	// consume it after installing its listener; rendering must leave it intact.
	let countryCode = 'CA';

	app?.hidePreloader();

	// Native shell: safe-area CSS var + legacy window.Cordova alias
	useEffect(() => {
		initNativeAppShell()
	}, [])

	// Bootstrap feature flags for hybrid environment
	useEffect(() => {
		(window as any).TempStars = (window as any).TempStars || {}
		;(window as any).TempStars.FeatureFlags = (window as any).TempStars.FeatureFlags || {}
		if (typeof (window as any).TempStars.FeatureFlags.reactAutoBookEnabled === 'undefined') {
			(window as any).TempStars.FeatureFlags.reactAutoBookEnabled = true
		}
		if (typeof (window as any).TempStars.FeatureFlags.unifiedPostedShiftEnabled === 'undefined') {
			(window as any).TempStars.FeatureFlags.unifiedPostedShiftEnabled = true
		}
	}, [])

	const THEME = createTheme({
		typography: {
			fontFamily: [
				'Poppins',
				'sans-serif',
			  ].join(','),
		}
	 });

	return (
		<ThemeProvider theme={THEME}>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<MemoryRouter
					initialEntries={['landing']}
				>
					<DefaultRoute/>
					<SaveData
						countryCode={countryCode}
					/>
					<AvailableJobsBrowserBackHandler/>
					<AndroidBackButtonHandler/>

					<Route path={'landing'} component={Landing}/>

					{/* Dentist Routes */}
					<Route path={'dentistHome'} component={DentistHomePage}/>
					<Route path={'dentistInvoices'} component={InvoicesPage}/>
					<Route path={'dentistLocations'} component={LocationsListPage}/>
					<Route path={'locationAdd'} component={LocationAddPage}/>
					<Route path={'locationDetails'} component={LocationDetailsPage}/>
					<Route path={'paymentInfo'} component={PaymentInfoPage}/>
					<Route path={'jobBoard'} component={JobBoardPage}/>
					<Route path={'jobBoardDetails'} component={JobBoardDetailsPage}/>
					<Route path={'jobInfo'} component={JobInfoPage}/>
					<Route path={'candidate'} component={CandidatePage}/>
					<Route path={'candidateResume'} component={CandidateResumePage}/>
					<Route path={'jobBoardCandidate'} component={JobBoardCandidateTemplatePage}/>
					<Route path={'jobFeedback'} component={JobPostFeedbackPage}/>
					<Route path={'deleteSuccess'} component={JobDeleteSuccessPage}/>
					<Route path={'postPosition'} component={EditJobPostPositionPage}/>
					<Route path={'postOfficeLocation'} component={EditJobPostOfficeLocationPage}/>
					<Route path={'postAvailability'} component={EditJobPostAvailabilityPage}/>
					<Route path={'postDates'} component={EditJobPostDatesPage}/>
					<Route path={'postCandidateRequirements'} component={EditJobPostCandidateRequirementsPage}/>
					<Route path={'postTitleDescription'} component={EditJobPostTitleDescriptionPage}/>
					<Route path={'postConfirmation'} component={EditJobPostConfirmationPage}/>
					<Route path={'postSuccess'} component={EditJobPostSuccessPage}/>
					<Route path={'customOfferDetails'} component={CustomOfferDetailsPage}/>
					<Route path={'dentistCustomOffers'} component={CustomOffersPage}/>
					<Route path={'hygienistCancelJob'} component={CancelJobPage}/>
					<Route path={'jobPosted'} component={JobPostedPage}/>
					<Route path={'jobCompleted'} component={JobCompletedPage}/>
					<Route path={'feedbackPage'} component={FeedbackPage}/>
					
					{/* New Edit Job Routes */}
					<Route path={'editJobFirstStep'} component={EditJobPostFirstStep}/>
					<Route path={'editJobSecondStep'} component={EditJobPostSecondStep}/>
					<Route path={'editJobOverviewStep'} component={EditJobPostOverviewStep}/>

					<Route path={'SignUp_PaymentInfo'} component={SignUp_PaymentInfo}/>

					<Route path={'postJob'} component={PostJob}/>
					<Route path={'dentistJobsForDate'} component={DentistJobsForDatePage}/>
					<Route path={'dentistCeCourses'} component={OfficeCeCoursesPage}/>
					<Route path={'invoice'} component={InvoicePage}/>
					<Route path={'dentistJobConfirmed'} component={DentistConfirmedOfferPage}/>
					<Route path={'messenger'} component={DentistMessengerPage}/>
					<Route path={'customOffer'} component={CustomOfferPage}/>
					<Route path={'modifyJob'} component={ModifyJobPage}/>
					<Route path={'hygienistContactSupport'} component={ContactSupport}/>
					<Route path={'dentistContactSupport'} component={DOContactSupport}/>

					{/* Delete Account Route */}
					<Route path={'hygienistDeleteAccount'} component={HygienistDeleteAccount}/>
					<Route path={'hygienistDeleteAccountSecondStep'} component={HygienistDeleteAccountSecondStep}/>

					<Route path={'dentistDeleteAccount'} component={DentistDeleteAccount}/>

					{/* Hygienist Routes */}
					<Route path={'hygienistHome'} component={HygienistHomePage}/>
					<Route path={'hygienistJobHistory'} component={HygienistJobHistoryPage}/>
					<Route path={'availableJobs'} component={AvailableJobsPage}/>
					<Route path={'availableJob'} component={AvailableJobPage}/>
					<Route path={'partialOffer'} component={PartialOfferPage}/>
					<Route path={'confirmedOffer'} component={ConfirmedOfferPage}/>
					<Route path={'hygienistInstabookConfirmation'} component={InstaBookConfirmationPage}/>
					<Route path={'hygienistMessenger'} component={HygienistMessengerPage}/>
					<Route path={'completeJob'} component={CompleteJobPage}/>
					<Route path={'hygienistProfile'} component={ProfilePage}/>
					<Route path={'forcedQualification'} component={ForcedQualificationPage}/>
                    <Route path={'hygienistInvoices'} component={HygienistInvoicesList}/>
                    <Route path={'hygienistInvoice'} component={HygienistInvoicePage}/>
                    <Route path={'paymentInformation'} component={PaymentInformationPage}/>
                    <Route path={'invoiceDispute'} component={InvoiceDisputePage}/>
                    <Route path={'manualBookShift'} component={ManualBookShiftPage}/>
					<Route path={'myStats'} component={MyStats}/>
					<Route path={'hygienistFeedback'} component={HygienistFeedbackPage}/>
					<Route path={'hygienist/feedback'} component={HygienistFeedbackPage}/>
					<Route path={'autoBook'} component={AutoBookPage}/>
					<Route path={'coursesHome'} component={CoursesHomePage}/>
					<Route path={'courseDetails'} component={CourseDetailsPage}/>
					<Route path={'coursePlayer'} component={CoursePlayerPage}/>
					<Route path={'courseReturn'} component={CourseReturnPage}/>

					{/* Tools Routes (Test Accounts Only) */}
					<Route path={'MixpanelLogs'} component={MixpanelLogs}/>

					{/* ASSOCIATE DENTIST Home Route */}
					<Route path={'jobPostsList'} component={JobPostsListPage}/>
					<Route path={'jobAlerts'} component={JobAlertsPage}/>
					<Route path={'jobPostDetails'} component={JobPostDetailsPage}/>

					{/* Landing Routes */}
					<Route path={'MarketingMessaging'} component={MarketingMessaging}/>
					<Route path={'ForgotPassword'} component={ForgotPassword}/>
					<Route path={'ResetPassword'} component={ResetPassword}/>
					<Route path={'Login'} component={Login}/>
					<Route path={'RoleSelect'} component={RoleSelect}/>
					<Route path={'SignUp0'} component={SignUp0}/>
					<Route path={'SignUp1_DO'} component={SignUp1_DO}/>
					<Route path={'SignUp2_DO'} component={SignUp2_DO}/>
					<Route path={'SignUp1_Talent'} component={SignUp1_Talent}/>
					<Route path={'SignUp2_Talent'} component={SignUp2_Talent}/>
					<Route path={'Onboarding_DO'} component={Onboarding_DO}/>
					<Route path={'Onboarding_Talent'} component={Onboarding_Talent}/>
					<Route path={'Download'} component={Download}/>

					{/* Loading Route */}

					<Route path={'loading'}>
						<div className="background">
							Page redirecting...
						</div>
					</Route>
					{/*<Route path="*">*/}
					{/*	<div className="background">*/}
					{/*		Loading...*/}
					{/*	</div>*/}
					{/*</Route>*/}
				</MemoryRouter>
			</PersistGate>
			{/* This thing serves absolutely no reason.
			 However, every route should have at least one @material-ui
			 element in it's tree, otherwise the production build fails
			 for some reason with some strange errors after
			 being embedded into the root Cordova project 🤷‍
			 If you're reading this, press F. */}
			<ClearIcon style={{display: 'none'}}/>
		</Provider>
		</ThemeProvider>
	);
}

function SaveData({countryCode}: { countryCode: string }) {
	const setCountry = usePersistedState({
		entityName: entities.countryCode,
	})[1]
	useEffect(() => {
		setCountry(countryCode)
	}, [setCountry, countryCode])
	return null
}

export default App
